/**
 * Product Card V3 - Horizontal pack selector with inline pricing
 * ES6 Module - imports shared utilities from product-card-core.js
 */
import {
    formatMoney,
    addToCart,
    updateCartBubbleFromServer,
    getTierConfig,
    buildBfProperties,
    applyBFPackPricing,
    calculatePercentOff,
    calculateSavings,
    getMoneyFormat
} from './product-card-core.js';
import { log } from './np-logger.js';

'use strict';

// Prevent double initialization
if (window.ProductCardV3 && window.ProductCardV3._initialized) {
    log('[PRODUCT-CARD V3] Already initialized, skipping');
} else {

(function($) {
    $(document).ready(function() {
        log('[PRODUCT-CARD V3] Initializing...');

        // Apply BF pricing to V3 cards
        $('.product-card-v3[data-bf-pack-1-usd]').each(function() {
            applyBFPackPricing($(this));
        });

        // V3 Card initialization
        $('.product-card-v3').each(function() {
            const $card = $(this);
            initializeV3Card($card);
        });

        // Choose options open for V3
        $(document).on('click', '.product-card-v3 .choose-options-btn button', function() {
            const $card = $(this).closest('.product-card-v3');
            const directAtcMode = $card.attr('data-direct-atc') === 'true';

            // Bundles collection mode: closed-card CTA should add directly to cart.
            if (directAtcMode) {
                handleAddToCartClick($card, $(this));
                return;
            }

            const $optionsContainer = $card.find('.product-card-options');
            const $cardBox = $card.find('.product-card-box');

            $optionsContainer.removeClass('bf-2025--hidden');
            $cardBox.addClass('bf-2025--hidden');
            $card.addClass('active');

            // Apply default settings if configured
            const defaultSubscribe = $card.attr('data-default-subscribe') === 'true';
            if (defaultSubscribe) {
                const $subscribeOption = $card.find('.purchase-option.subscribe');
                if ($subscribeOption.length && !$subscribeOption.hasClass('active')) {
                    $subscribeOption.trigger('click');
                }
            }
        });

        // Close options for V3
        $(document).on('click', '.product-card-v3 .close-options-btn', function() {
            const $card = $(this).closest('.product-card-v3');
            const $optionsContainer = $card.find('.product-card-options');
            const $cardBox = $card.find('.product-card-box');

            $optionsContainer.addClass('bf-2025--hidden');
            $cardBox.removeClass('bf-2025--hidden');
            $card.removeClass('active');
        });

        // Pack option click
        $(document).on('click', '.product-card-v3 .pack-option', function() {
            const $option = $(this);
            const $card = $option.closest('.product-card-v3');

            // Update active state
            $card.find('.pack-option').removeClass('active');
            $option.addClass('active');

            // Update card data
            const packNumber = parseInt($option.attr('data-pack-number'));
            const variantId = $option.attr('data-variant-id');
            $card.attr('data-variant-id', variantId);
            $card.attr('data-selected-pack', packNumber);

            // Update subscription dropdown for new variant
            updateSubscriptionDropdown($card, variantId);

            // Recalculate and update all displays
            updateAllDisplays($card);
        });

        // Pack + color/style swatch click
        $(document).on('click', '.product-card-v3 .pc-suboption__swatch', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const $swatch = $(this);
            const $card = $swatch.closest('.product-card-v3');
            if ($card.attr('data-variant-type') !== 'pack-sub') return;

            $card.find('.pc-suboption__swatch').removeClass('active').attr('aria-selected', 'false');
            $swatch.addClass('active').attr('aria-selected', 'true');

            const subValue = $swatch.attr('data-value');
            $card.attr('data-selected-sub', subValue);
            applyPackSubSelection($card);
        });

        // Flavor dropdown toggle
        $(document).on('click', '.product-card-v3 .flavor-dropdown-selected', function(e) {
            e.stopPropagation();
            const $dropdown = $(this).closest('.flavor-dropdown');
            // Close any other open dropdowns first
            $('.product-card-v3 .flavor-dropdown.open').not($dropdown).removeClass('open');
            $dropdown.toggleClass('open');
        });

        // Close dropdown when clicking outside
        $(document).on('click', function(e) {
            if (!$(e.target).closest('.flavor-dropdown').length) {
                $('.product-card-v3 .flavor-dropdown.open').removeClass('open');
            }
        });

        // Flavor option click (for flavor + non-pack named variant products)
        $(document).on('click', '.product-card-v3 .flavor-option', function(e) {
            e.stopPropagation();
            const $option = $(this);
            const $card = $option.closest('.product-card-v3');
            const $dropdown = $option.closest('.flavor-dropdown');
            const variantType = $card.attr('data-variant-type');

            // Don't allow selecting sold-out flavors
            if ($option.attr('data-sold-out') === 'true') {
                return;
            }

            // Update active state
            $card.find('.flavor-option').removeClass('active');
            $option.addClass('active');

            // Update the selected display
            const variantTitle = $option.attr('data-variant-title');
            const variantImage = $option.attr('data-variant-image');
            $dropdown.find('.selected-flavor-name').text(variantTitle);
            if (variantImage) {
                const $selectedImg = $dropdown.find('.selected-flavor-img');
                if ($selectedImg.length) {
                    $selectedImg.attr('src', variantImage).show();
                } else {
                    $dropdown.find('.flavor-dropdown-selected').prepend(
                        `<img src="${variantImage}" alt="${variantTitle}" class="selected-flavor-img" loading="lazy">`
                    );
                }
            }

            // Close the dropdown
            $dropdown.removeClass('open');

            // Update card variant ID
            const variantId = $option.attr('data-variant-id');
            $card.attr('data-variant-id', variantId);

            // Update subscription dropdown for new variant
            updateSubscriptionDropdown($card, variantId);

            if (variantType === 'non-pack') {
                // Sync hidden pack-option so shared pricing helpers keep working
                const $syncOption = $card.find('.non-pack-variant-selector .pack-option').first();
                if ($syncOption.length) {
                    $syncOption
                        .attr('data-variant-id', variantId)
                        .attr('data-price', $option.attr('data-price') || 0)
                        .attr('data-compare-at-price', $option.attr('data-compare-at-price') || 0)
                        .addClass('active');
                }

                if (variantImage) {
                    const largerImg = variantImage.replace('60x60', '200x200');
                    $card.find('.product-details-cover').attr('src', largerImg);
                }

                updateAllDisplays($card);
            } else {
                // Recalculate and update all displays (tiered qty pricing)
                updateFlavorDisplays($card);
            }
        });

        // Qty option click (for flavor variant products - separate from variant selection)
        $(document).on('click', '.product-card-v3 .qty-option', function() {
            const $option = $(this);
            const $card = $option.closest('.product-card-v3');

            // Update active state
            $card.find('.qty-option').removeClass('active');
            $option.addClass('active');

            // Update selected qty
            const qty = parseInt($option.attr('data-qty'));
            $card.attr('data-selected-qty', qty);

            // Recalculate and update all displays
            updateFlavorDisplays($card);
        });

        // Purchase type change
        $(document).on('click', '.product-card-v3 .purchase-option', function() {
            const $option = $(this);
            const $card = $option.closest('.product-card-v3');
            const purchaseType = $option.attr('data-type');

            // Update active state
            $card.find('.purchase-option').removeClass('active');
            $option.addClass('active');

            // Update card purchase type
            $card.attr('data-purchase-type', purchaseType);

            // Toggle subscription frequency visibility
            const $frequencyWrapper = $card.find('.subscription-frequency-wrapper');
            if (purchaseType === 'subscribe_save') {
                $frequencyWrapper.removeClass('bf-2025--hidden');
                // Set selling plan value
                const planId = $card.find('.subscription-frequency-select').val() || $card.attr('data-preselect-plan');
                $card.find('input[name="selling_plan"]').val(planId);
            } else {
                $frequencyWrapper.addClass('bf-2025--hidden');
                $card.find('input[name="selling_plan"]').val('');
            }

            // Recalculate and update all displays (use correct function based on mode)
            const isFlavorMode = $card.attr('data-variant-type') === 'flavor';
            if (isFlavorMode) {
                updateFlavorDisplays($card);
            } else {
                updateAllDisplays($card);
            }
        });

        // Subscription frequency change
        $(document).on('change', '.product-card-v3 .subscription-frequency-select', function() {
            const $select = $(this);
            const $card = $select.closest('.product-card-v3');
            const planId = $select.val();
            $card.find('input[name="selling_plan"]').val(planId);
            log('[PRODUCT-CARD V3] Subscription frequency changed to:', planId);
        });

        // Quick View Image Modal
        $('#imagesModal').on('show.bs.modal', function (event) {
            log('[PRODUCT-CARD V3] Image modal shown');
            let button = $(event.relatedTarget);
            let card = button.closest('.slick-slide, .grid__item, .product-card, .product-card-v3');
            let images = card.find('.image-grid-product');

            let modal = $(this);
            if (images.length > 0 && images.get(0)) {
                modal.find('.modal-body').html(images.get(0).outerHTML);
            }
        });

        // Bundle "show more" expand/collapse
        $(document).on('click', '.product-card-v3 .show-more-btn', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const button = this;
            const container = button.parentElement && button.parentElement.querySelector('.hidden-bundles');
            if (!container) return;
            const isHidden = container.style.display === 'none' || container.style.display === '';
            container.style.display = isHidden ? 'block' : 'none';
            button.innerText = isHidden
                ? '- Show less'
                : (button.getAttribute('data-original-text') || button.innerText);
        });

        // Add to cart
        $(document).on('click', '.product-card-v3 .add-to-cart-v3-btn', function() {
            const $btn = $(this);
            const $card = $btn.closest('.product-card-v3');
            handleAddToCartClick($card, $btn);
        });

        log('[PRODUCT-CARD V3] Initialized');
    });

    function handleAddToCartClick($card, $btn) {
            if (!$card || !$card.length || !$btn || !$btn.length) return;
            const variantId = $card.attr('data-variant-id');
            const purchaseType = $card.attr('data-purchase-type');
            const planId = $card.find('input[name="selling_plan"]').val();
            const isBfProduct = $card.attr('data-bf-product') === 'true';
            const isFlavorMode = $card.attr('data-variant-type') === 'flavor';

            // For flavor mode, use selected qty from qty selector
            // For pack mode, always add 1 (the variant IS the pack)
            let quantity = 1;
            if (isFlavorMode) {
                const $activeQty = $card.find('.qty-option.active');
                quantity = parseInt($activeQty.attr('data-qty')) || 1;
            }

            const product = {
                variantId: parseInt(variantId),
                quantity: quantity,
                planId: purchaseType === 'subscribe_save' && planId ? parseInt(planId) : null
            };

            if (isBfProduct) {
                product.properties = buildBfProperties('product', getTierConfig($card), $card);
            }

            addToCart([product], false, $card, $btn, $btn.html());
    }

    /**
     * Initialize a V3 card with proper state
     */
    function initializeV3Card($card) {
        const sellingPlansRaw = $card.attr('data-selling-plans') || '[]';
        let sellingPlansData = [];
        try {
            sellingPlansData = JSON.parse(sellingPlansRaw);
        } catch (e) {
            console.warn('[PRODUCT-CARD V3] Could not parse selling plans:', e);
        }
        $card.data('sellingPlans', sellingPlansData);

        if ($card.attr('data-variant-type') === 'pack-sub') {
            let packMatrix = [];
            try {
                packMatrix = JSON.parse($card.attr('data-pack-matrix') || '[]');
            } catch (e) {
                console.warn('[PRODUCT-CARD V3] Could not parse pack matrix:', e);
            }
            $card.data('packMatrix', packMatrix);
        }

        // Initialize subscription dropdown for initial variant
        const initialVariantId = $card.attr('data-variant-id');
        updateSubscriptionDropdown($card, initialVariantId);

        // Check if this is a flavor mode card
        const isFlavorMode = $card.attr('data-variant-type') === 'flavor';

        if (isFlavorMode) {
            // Initialize flavor mode displays with currency conversion
            initializeFlavorCard($card);
        } else {
            // Update all displays with initial state (pack / pack-sub / non-pack mode)
            updateAllDisplays($card);
        }
    }

    /**
     * Resolve pack options + selected variant for pack×color products
     */
    function applyPackSubSelection($card) {
        const matrix = $card.data('packMatrix') || [];
        const selectedSub = $card.attr('data-selected-sub');
        let selectedPack = parseInt($card.attr('data-selected-pack'), 10) || 1;
        const moneyFormat = getMoneyFormat($card);
        const subscribeDiscount = parseFloat($card.attr('data-subscribe-discount')) || 0.85;
        const isSubscription = $card.attr('data-purchase-type') === 'subscribe_save';

        const byPack = {};
        matrix.forEach((entry) => {
            if (entry.sub !== selectedSub) return;
            byPack[entry.pack] = entry;
        });

        // Keep current pack if available for this color; otherwise fall back to first available
        if (!byPack[selectedPack]) {
            const availablePacks = Object.keys(byPack).map(Number).sort((a, b) => a - b);
            selectedPack = availablePacks[0] || selectedPack;
            $card.attr('data-selected-pack', selectedPack);
        }

        $card.find('.pack-option').each(function() {
            const $opt = $(this);
            const packNumber = parseInt($opt.attr('data-pack-number'), 10) || 1;
            const entry = byPack[packNumber];
            if (!entry) {
                $opt.addClass('bf-2025--hidden').removeClass('active');
                return;
            }

            $opt.removeClass('bf-2025--hidden');
            $opt.attr('data-variant-id', entry.id);
            $opt.attr('data-price', entry.price);
            $opt.attr('data-compare-at-price', entry.compare_at || 0);
            if (entry.available === false) {
                $opt.attr('data-sold-out', 'true');
            } else {
                $opt.removeAttr('data-sold-out');
            }

            const displayPrice = isSubscription
                ? Math.round(entry.price * subscribeDiscount)
                : entry.price;
            const perUnit = Math.round(displayPrice / packNumber);
            $opt.find('.pack-price').text(formatMoney(perUnit, moneyFormat));
        });

        let $active = $card.find(`.pack-option[data-pack-number="${selectedPack}"]`);
        if (!$active.length || $active.hasClass('bf-2025--hidden')) {
            $active = $card.find('.pack-option:not(.bf-2025--hidden)').first();
        }
        $card.find('.pack-option').removeClass('active');
        if ($active.length) {
            $active.addClass('active');
            const variantId = $active.attr('data-variant-id');
            const packNumber = parseInt($active.attr('data-pack-number'), 10) || selectedPack;
            $card.attr('data-variant-id', variantId);
            $card.attr('data-selected-pack', packNumber);
            updateSubscriptionDropdown($card, variantId);

            const entry = byPack[packNumber];
            if (entry && entry.image) {
                $card.find('.product-details-cover').attr('src', entry.image);
            }
        }

        updateAllDisplays($card);
    }

    /**
     * Update subscription dropdown options for a variant
     */
    function updateSubscriptionDropdown($card, variantId) {
        const sellingPlansData = $card.data('sellingPlans') || [];
        const $dropdown = $card.find('.subscription-frequency-select');
        const $subscribeOption = $card.find('.purchase-option.subscribe');

        if (!sellingPlansData.length) {
            $subscribeOption.hide();
            // If currently on subscribe mode, switch to one_time
            if ($card.attr('data-purchase-type') === 'subscribe_save') {
                $card.find('.purchase-option.one-time').trigger('click');
            }
            return;
        }

        const variantPlans = sellingPlansData.filter(p => p.variant_id == variantId);

        if (variantPlans.length === 0) {
            $subscribeOption.hide();
            // If currently on subscribe mode, switch to one_time
            if ($card.attr('data-purchase-type') === 'subscribe_save') {
                $card.find('.purchase-option.one-time').trigger('click');
            }
            return;
        }

        $subscribeOption.show();

        // Build dropdown options
        let options = '';
        variantPlans.forEach(plan => {
            const isDefault = plan.name.toLowerCase().includes('7 weeks');
            options += `<option value="${plan.id}"${isDefault ? ' selected' : ''}>${plan.name}${isDefault ? ' (most common)' : ''}</option>`;
        });
        $dropdown.html(options);

        // Update hidden input if in subscribe mode
        if ($card.attr('data-purchase-type') === 'subscribe_save') {
            $card.find('input[name="selling_plan"]').val($dropdown.val());
        }
    }

    /**
     * Update all price displays for a V3 card
     */
    function updateAllDisplays($card) {
        const $activePackOption = $card.find('.pack-option.active');
        const packNumber = parseInt($activePackOption.attr('data-pack-number')) || 1;
        const purchaseType = $card.attr('data-purchase-type') || 'one_time';
        const subscribeDiscount = parseFloat($card.attr('data-subscribe-discount')) || 0.85;
        const moneyFormat = getMoneyFormat($card);

        // Get base prices from active pack option
        let basePrice = parseInt($activePackOption.attr('data-price')) || 0;
        let compareAtPrice = parseInt($activePackOption.attr('data-compare-at-price')) || 0;

        // Check if BF pricing is applied
        if ($card.attr('data-bf-converted') === 'true') {
            basePrice = parseInt($card.attr('data-bf-pack-' + packNumber)) || basePrice;
            compareAtPrice = parseInt($card.attr('data-compare-at-pack-' + packNumber)) || compareAtPrice;
        }

        // Calculate subscription price
        const subscribePrice = Math.round(basePrice * subscribeDiscount);

        // Determine current prices based on purchase type
        const isSubscription = purchaseType === 'subscribe_save';
        const currentPrice = isSubscription ? subscribePrice : basePrice;
        const oneTimePercentOff = calculatePercentOff(compareAtPrice, basePrice);
        const subscribePercentOff = Math.round((1 - subscribeDiscount) * 100);
        // Combined: sale % off + subscribe extra % (e.g. 45 + 15 = 60)
        const combinedPercentOff = oneTimePercentOff + subscribePercentOff;
        const currentCompareAt = isSubscription
            ? (compareAtPrice > 0 ? compareAtPrice : basePrice)
            : compareAtPrice;

        // Calculate percent off and savings
        const percentOff = isSubscription ? combinedPercentOff : calculatePercentOff(currentCompareAt, currentPrice);
        const savings = calculateSavings(currentCompareAt, currentPrice);
        const percentOffLabel = percentOff > 0 ? percentOff + '% off' : '';

        // Update closed-card badge + options product-details badge
        const $percentOffBadges = $card.find('.product-card-box .percent-off, .product-details .percent-off');
        $percentOffBadges.text(percentOffLabel);
        $percentOffBadges.toggle(percentOff > 0);

        // Update product details prices
        $card.find('.product-details .discounted-price').text(formatMoney(currentPrice, moneyFormat));
        $card.find('.product-details .original-price').text(formatMoney(currentCompareAt, moneyFormat));

        // Update One-Time Purchase option
        $card.find('.purchase-option.one-time .option-price').text(formatMoney(basePrice, moneyFormat));
        if (compareAtPrice > 0) {
            $card.find('.purchase-option.one-time .option-compare-price').text(formatMoney(compareAtPrice, moneyFormat)).show();
            $card.find('.purchase-option.one-time .option-percent-off').text(oneTimePercentOff + '% off').show();
        } else {
            $card.find('.purchase-option.one-time .option-compare-price').hide();
            $card.find('.purchase-option.one-time .option-percent-off').hide();
        }

        // Update Subscribe & Save option
        $card.find('.purchase-option.subscribe .option-price').text(formatMoney(subscribePrice, moneyFormat));
        $card.find('.purchase-option.subscribe .option-compare-price').text(formatMoney(basePrice, moneyFormat));
        $card.find('.purchase-option.subscribe .extra-off-badge').text('EXTRA ' + subscribePercentOff + '% OFF');

        // Update Add to Cart button
        $card.find('.add-to-cart-v3-btn .cart-total-price').text(formatMoney(currentPrice, moneyFormat));

        // Update savings display
        const totalSavings = isSubscription
            ? calculateSavings(compareAtPrice, subscribePrice)
            : savings;
        $card.find('.savings-display .savings-amount').text(formatMoney(totalSavings, moneyFormat));

        // Update pack option per-pack prices (adjust for subscription if needed)
        if (isSubscription) {
            $card.find('.pack-option').each(function() {
                const $opt = $(this);
                const pn = parseInt($opt.attr('data-pack-number')) || 1;
                let packPrice = parseInt($opt.attr('data-price')) || 0;

                // Use BF converted price if available
                if ($card.attr('data-bf-converted') === 'true') {
                    packPrice = parseInt($card.attr('data-bf-pack-' + pn)) || packPrice;
                }

                const subPackPrice = Math.round(packPrice * subscribeDiscount);
                const perUnitPrice = Math.round(subPackPrice / pn);
                $opt.find('.pack-price').text(formatMoney(perUnitPrice, moneyFormat));
            });
        } else {
            // Reset to one-time prices
            $card.find('.pack-option').each(function() {
                const $opt = $(this);
                const pn = parseInt($opt.attr('data-pack-number')) || 1;
                let packPrice = parseInt($opt.attr('data-price')) || 0;

                // Use BF converted price if available
                if ($card.attr('data-bf-converted') === 'true') {
                    packPrice = parseInt($card.attr('data-bf-pack-' + pn)) || packPrice;
                }

                const perUnitPrice = Math.round(packPrice / pn);
                $opt.find('.pack-price').text(formatMoney(perUnitPrice, moneyFormat));
            });
        }

        // Update variant image if available
        const variantType = $card.attr('data-variant-type');
        if (variantType === 'non-pack') {
            const $activeNonPack = $card.find('.flavor-option.active');
            const nonPackImg = $activeNonPack.attr('data-variant-image');
            if (nonPackImg) {
                $card.find('.product-details-cover').attr('src', nonPackImg.replace('60x60', '200x200'));
            }
        } else if (variantType === 'pack-sub') {
            const matrix = $card.data('packMatrix') || [];
            const selectedSub = $card.attr('data-selected-sub');
            const entry = matrix.find((item) => item.sub === selectedSub && item.pack === packNumber);
            if (entry && entry.image) {
                $card.find('.product-details-cover').attr('src', entry.image);
            }
        } else {
            const handle = $card.attr('data-handle');
            fetchVariantImage($card, handle, packNumber);
        }
    }

    /**
     * Fetch and update variant image
     */
    async function fetchVariantImage($card, handle, packNumber) {
        try {
            const response = await fetch(`/products/${handle}.js`);
            const data = await response.json();

            const variant = data.variants.find(v =>
                v.title.toLowerCase().includes(packNumber.toString()) &&
                v.title.toLowerCase().includes('pack')
            );

            if (variant && variant.featured_image) {
                $card.find('.product-details-cover').attr('src', variant.featured_image.src);
                const cleanTitle = data.title.replace('(BFCM)', '').replace('BLK - ', '').replace('(BLK)', '').trim();
                $card.find('.product-details .product-name').text(cleanTitle);
            }
        } catch (error) {
            console.warn('[PRODUCT-CARD V3] Could not fetch variant image:', error);
        }
    }

    /**
     * Update displays for flavor mode cards (Sniff N Sip pattern)
     * Prices are tiered by qty, not by variant
     */
    function updateFlavorDisplays($card) {
        const $activeQtyOption = $card.find('.qty-option.active');
        const $activeFlavorOption = $card.find('.flavor-option.active');
        const selectedQty = parseInt($activeQtyOption.attr('data-qty')) || 1;
        const purchaseType = $card.attr('data-purchase-type') || 'one_time';
        const subscribeDiscount = parseFloat($card.attr('data-subscribe-discount')) || 0.85;
        const moneyFormat = getMoneyFormat($card);

        // Get currency rate (same as Sniff N Sip LP)
        const currencyRate = (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;

        // Get USD price from active qty option and convert
        const usdPrice = parseInt($activeQtyOption.attr('data-price')) || 0;
        const basePrice = Math.round(usdPrice * currencyRate);
        const perEachPrice = Math.round(basePrice / selectedQty);

        // Calculate subscription price
        const subscribePrice = Math.round(basePrice * subscribeDiscount);
        const subscribePerEach = Math.round(subscribePrice / selectedQty);

        // Determine current prices based on purchase type
        const isSubscription = purchaseType === 'subscribe_save';
        const currentPrice = isSubscription ? subscribePrice : basePrice;
        const currentPerEach = isSubscription ? subscribePerEach : perEachPrice;

        // Update qty option prices (convert all from USD)
        $card.find('.qty-option').each(function() {
            const $opt = $(this);
            const qty = parseInt($opt.attr('data-qty')) || 1;
            const optUsdPrice = parseInt($opt.attr('data-price')) || 0;
            const optPrice = Math.round(optUsdPrice * currencyRate);
            const optPerEach = Math.round(optPrice / qty);

            // Apply subscription discount if active
            const displayPrice = isSubscription ? Math.round(optPrice * subscribeDiscount) : optPrice;
            const displayPerEach = isSubscription ? Math.round(displayPrice / qty) : optPerEach;

            // Show per-each price in qty selector (not total)
            $opt.find('.qty-price').text(formatMoney(displayPerEach, moneyFormat));
        });

        // Update product details + closed-card badge
        const subscribePercentOff = Math.round((1 - subscribeDiscount) * 100);
        const percentOffLabel = isSubscription ? subscribePercentOff + '% off' : '';
        $card.find('.product-details .discounted-price').text(formatMoney(currentPrice, moneyFormat));
        $card.find('.product-details .original-price').text(formatMoney(basePrice, moneyFormat)).toggle(isSubscription);
        $card.find('.product-card-box .percent-off, .product-details .percent-off')
            .text(percentOffLabel)
            .toggle(isSubscription);

        // Update One-Time Purchase option
        $card.find('.purchase-option.one-time .option-price').text(formatMoney(basePrice, moneyFormat));
        $card.find('.purchase-option.one-time .option-compare-price').hide();
        $card.find('.purchase-option.one-time .option-percent-off').hide();

        // Update Subscribe & Save option
        $card.find('.purchase-option.subscribe .option-price').text(formatMoney(subscribePrice, moneyFormat));
        $card.find('.purchase-option.subscribe .option-compare-price').text(formatMoney(basePrice, moneyFormat));
        $card.find('.purchase-option.subscribe .extra-off-badge').text('EXTRA ' + subscribePercentOff + '% OFF');

        // Update Add to Cart button
        $card.find('.add-to-cart-v3-btn .cart-total-price').text(formatMoney(currentPrice, moneyFormat));

        // Update savings display (compare to 1-pack pricing for volume discount)
        const onePackUsdPrice = parseInt($card.find('.qty-option[data-qty="1"]').attr('data-price')) || 0;
        const onePackPrice = Math.round(onePackUsdPrice * currencyRate * selectedQty);
        const savings = onePackPrice - currentPrice;
        if (savings > 0) {
            $card.find('.savings-display .savings-amount').text(formatMoney(savings, moneyFormat));
            $card.find('.savings-display').show();
        } else {
            $card.find('.savings-display').hide();
        }

        // Update variant image from selected flavor
        if ($activeFlavorOption.length) {
            const flavorImg = $activeFlavorOption.find('img').attr('src');
            if (flavorImg) {
                // Convert to larger size for product details
                const largerImg = flavorImg.replace('60x60', '200x200');
                $card.find('.product-details-cover').attr('src', largerImg);
            }
            const flavorTitle = $activeFlavorOption.attr('data-variant-title');
            if (flavorTitle) {
                // Could update product name to include flavor if desired
            }
        }

        log('[PRODUCT-CARD V3] Flavor displays updated - qty:', selectedQty, 'price:', currentPrice);
    }

    /**
     * Initialize flavor mode card with currency conversion
     */
    function initializeFlavorCard($card) {
        // Initial price update
        updateFlavorDisplays($card);
    }

    // Expose for external use and BF pricing updates
    window.ProductCardV3 = {
        _initialized: true,
        updateAllDisplays: function($card) {
            if ($card && $card.length) {
                updateAllDisplays($card);
            }
        },
        initializeCard: function($card) {
            if ($card && $card.length) {
                initializeV3Card($card);
            }
        }
    };

})(jQuery);

}


log('[PRODUCT-CARD V3] Module loaded');
